import { render, staticRenderFns } from "./UserNav.vue?vue&type=template&id=182a7650&scoped=true&"
import script from "./UserNav.vue?vue&type=script&lang=js&"
export * from "./UserNav.vue?vue&type=script&lang=js&"
import style0 from "./UserNav.vue?vue&type=style&index=0&id=182a7650&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182a7650",
  null
  
)

export default component.exports